<script setup>
import { sendMetrik } from "@/utils/metrika";
import BaseButtonUploadReceipt from "@/components/ui/BaseButtonUploadReceipt.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper/modules";
</script>
<template>
	<section class="participation section" id="participation">
		<div class="container">
			<h2 class="participation__title title2">Как выиграть призы</h2>
			<div class="participation__slider">
				<Swiper
					:modules="[Navigation, Pagination]"
					:navigation="{
						nextEl: '.button-next',
						prevEl: '.button-prev',
					}"
					:pagination="{
						el: '.pagination',
					}"
					:breakpoints="{
						320: {
							slidesPerView: 1,
							spaceBetween: 15,
						},
						481: {
							slidesPerView: 1,
							spaceBetween: 20,
						},
						577: {
							slidesPerView: 2,
							spaceBetween: 10,
						},
						769: {
							slidesPerView: 2,
							spaceBetween: 60,
						},
						993: {
							slidesPerView: 3,
							spaceBetween: 20,
						},
						1025: {
							slidesPerView: 3,
							spaceBetween: 60,
						},
						1201: {
							slidesPerView: 4,
							spaceBetween: 60,
						},
					}"
					class="participation__swiper"
				>
					<SwiperSlide :class="['participation-slide']">
						<div class="participation-slide__header">
							<h6 class="participation-slide__title">Покупайте крупу <a href="#collections">«Мистраль»</a></h6>
						</div>
						<div class="participation-slide__image">
							<img class="full-img" width="300" height="300" src="@/assets/img/participation/participation_step_1.webp" alt="изображение" />
						</div>
					</SwiperSlide>
					<SwiperSlide :class="['participation-slide --step-2 ']">
						<div class="participation-slide__header">
							<h6 class="participation-slide__title">Зарегистрируйте <br> чек на сайте</h6>
							<BaseButtonUploadReceipt class="participation-slide__btn --small --blue">Загрузить чек</BaseButtonUploadReceipt>
						</div>
						<div class="participation-slide__image">
							<img class="full-img" width="300" height="300" src="@/assets/img/participation/participation_step_2.webp" alt="изображение" />
						</div>
					</SwiperSlide>
					<SwiperSlide :class="['participation-slide']">
						<div class="participation-slide__header">
							<h6 class="participation-slide__title">Участвуйте <br> в розыгрыше <a href="#prizes">призов </a></h6>
						</div>
						<div class="participation-slide__image">
							<img class="full-img" width="300" height="300" src="@/assets/img/participation/participation_step_3.webp" alt="изображение" />
						</div>
					</SwiperSlide>
					<SwiperSlide :class="['participation-slide']">
						<div class="participation-slide__header">
							<h6 class="participation-slide__title">Принимайте участие <br> в наших <a href="#games">играх</a></h6>
						</div>
						<div class="participation-slide__image">
							<img class="full-img" width="300" height="300" src="@/assets/img/participation/participation_step_4.webp" alt="изображение" />
						</div>
					</SwiperSlide>
					<div class="participation__pagination pagination"></div>
				</Swiper>
			</div>
		</div>
	</section>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
@use "@/assets/scss/blocks/swiper";

.participation {
	background-image: url("@/assets/img/participation/participation_line.svg");
	background-repeat: no-repeat;
	background-position: center 85%;
	background-size: contain;
	padding-top: 9.5rem;
	@media (max-width: vars.$x480) {
		padding-top: 4.2rem;
		background-image: url("@/assets/img/participation/participation_line_mobile.svg");
		background-position: center 50%;
	}
}

.participation-slide {
	border: 1px solid var(--border-inverse-3);
	border-radius: var(--border-radius);
	padding: 3.5rem 3rem 4rem;
	background: var(--fill-inverse-1);
	display: flex;
	align-items: center;
	flex-direction: column;
	gap: 3.2rem;
	height: auto;
	@media (max-width: vars.$x480) {
		padding: 2.8rem 3rem 3rem;
		gap: 10px;
	}
	&.--step-2 {
		.participation-slide__image {
			margin-top: -7.8rem;
			@media (max-width: vars.$x480) {
				margin-top: -6rem;
			}
		}
	}
}
.participation-slide__header {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2rem;
}
.participation-slide__title {
	font-weight: 500;
	font-size: 2.4rem;
	line-height: 120%;
	text-align: center;
	@media (max-width: vars.$x480) {
		font-size: 2rem;
		line-height: 120%;
	}
	a {
		font-weight: 700;
		line-height: 140%;
		text-decoration: underline;
		text-decoration-skip-ink: none;
		color: #0c4ca3;
		@media (hover: hover) {
			&:hover {
				text-decoration: none;
			}
		}
		@media (max-width: vars.$x480) {
			font-size: 2.4rem;
			line-height: 140%;
		}
	}
}
.participation-slide__image {
	width: 30rem;
	@media (max-width: vars.$x480) {
		width: 23rem;
		height: 23rem;
	}
	img {
		aspect-ratio: 1/1;
	}
}
.participation__pagination {
	display: none;
	@media (max-width: vars.$l) {
		display: flex;
		margin-top: 24px;
	}
}

.v-enter-active,
.v-leave-active {
	transition: 0.4s ease;
}

.v-enter-from,
.v-leave-to {
	opacity: 0;
	transform: translateY(10px);
}
</style>
